(function () {
  if (window.__cmSearchResultsView) return;
  window.__cmSearchResultsView = true;

  var storageKey = 'cm-search-results-view-v1';
  var selectedView = 'list';
  var observedLists = new WeakSet();
  try {
    if (window.localStorage.getItem(storageKey) === 'grid') selectedView = 'grid';
  } catch (error) {}

  function updateColorName(card) {
    var label = card.querySelector('[data-search-selected-color]');
    var name = card.querySelector('[data-search-color-name]');
    if (!label || !name) return;
    var active = card.querySelector('.c-collection-card__swatch--active[data-color-value]');
    if (!active) {
      var image = card.querySelector('.cm-search-result-card__image.c-collection-card__image--active');
      var variantId = image ? image.dataset.variantId : card.dataset.initialVariantId;
      card.querySelectorAll('.c-collection-card__swatch[data-color-value]').forEach(function (swatch) {
        if (swatch.dataset.variantId === variantId) active = swatch;
      });
    }
    if (active) {
      name.textContent = active.dataset.colorValue || '';
      label.hidden = !name.textContent.trim();
    }
  }

  function applyColors(list) {
    list.querySelectorAll('.cm-search-result-card').forEach(function (card) {
      card.querySelectorAll('.c-collection-card__swatch[data-color-value]').forEach(function (swatch) {
        swatch.setAttribute('title', swatch.dataset.colorValue);
      });
      updateColorName(card);
    });
    if (observedLists.has(list)) return;
    observedLists.add(list);
    // Native c-common.js owns selection, images and variant links. Follow its active classes.
    new MutationObserver(function (mutations) {
      var cards = new Set();
      mutations.forEach(function (mutation) {
        if (mutation.target.matches('.c-collection-card__swatch, .cm-search-result-card__image')) {
          var card = mutation.target.closest('.cm-search-result-card');
          if (card) cards.add(card);
        }
      });
      cards.forEach(updateColorName);
    }).observe(list, { attributes: true, attributeFilter: ['class'], subtree: true });
  }

  function applyView(root) {
    (root || document).querySelectorAll('.cm-search-product-results').forEach(function (list) {
      applyColors(list);
      list.dataset.searchView = selectedView;
      var section = list.closest('.cm-search-results--refined');
      if (!section) return;
      section.querySelectorAll('[data-search-view-controls] button[data-search-view]').forEach(function (button) {
        var active = button.dataset.searchView === selectedView;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
      var imageSizes = selectedView === 'grid'
        ? '(max-width: 999px) calc((100vw - 72px) / 2), 320px'
        : '(max-width: 699px) clamp(140px, 36vw, 152px), 220px';
      list.querySelectorAll('.cm-search-result-card__image').forEach(function (image) {
        image.setAttribute('sizes', imageSizes);
      });
    });
  }

  document.addEventListener('cm:search:rendered', function (event) { applyView(event.detail.root); });

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-search-view-controls] button[data-search-view]');
    if (!button) return;
    var controls = button.closest('[data-search-view-controls]');
    var list = document.getElementById(controls.dataset.controls);
    if (!list || !list.classList.contains('cm-search-product-results')) return;
    var view = button.dataset.searchView;
    if (view !== 'list' && view !== 'grid') return;
    selectedView = view;
    applyView(list.closest('.cm-search-results--refined'));
    try { window.localStorage.setItem(storageKey, selectedView); } catch (error) {}
  });

  document.documentElement.addEventListener('theme:loading:end', function () {
    window.requestAnimationFrame(function () { applyView(document); });
  });
  document.addEventListener('shopify:section:load', function (event) { applyView(event.target); });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { applyView(document); }, { once: true });
  } else {
    applyView(document);
  }
})();
